import copy from 'copy-to-clipboard';
import { Dialog } from 'vant';

export default function download(url) {
  copy(url);
  Dialog({ message: '文件链接已复制到剪贴板，请粘贴到浏览器下载' });
}



// WEBPACK FOOTER //
// ./src/utils/download.js